"use strict";

import Vue from 'vue';
import axios from "axios";
import {
    getStore,
    setStore
} from './storage';
import router from '../router/index';
import { Message } from 'view-design';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    response => {
        // debugger
        const data = response.data;
        // 根据返回的code值来做不同的处理(和后端约定)
        switch (data.code) {
            case -4:
                // 未登录 清除已登录状态
                // setStore('accessToken', '');
                router.push({ name: 'Login' });
                Message.error(data.info);
                break;
            case -7:
                Message.error(data.info);
                break;
            // case 403:
            //   // 没有权限
            //   if (data.message !== null) {
            //     // Message.error(data.message);
            //   } else {
            //     // Message.error("未知错误");
            //   }
            //   break;
            // case 500:
            //   // 错误
            //   if (data.message !== null) {
            //     // Message.error(data.message);
            //   } else {
            //     // Message.error("未知错误");
            //   }
            //   break;
            default:
                return data;
        }
        return data;
    }, (err) => {
        // 返回状态码不为200时候的错误处理
        Message.error('您没有权限，请联系管理员!');
        return Promise.resolve(err);
    });

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;

export const getRequest = (url, params) => {
    let Authorization = getStore("Authorization");
    return axios({
        method: 'get',
        url: `${url}`,
        data: params,
        // transformRequest: [function(data) {
        //     let ret = '';
        //     for (let it in data) {
        //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        //     }
        //     ret = ret.substring(0, ret.length - 1);
        //     return ret;
        // }],
        headers: {
            'Authorization': Authorization,
            'pageNum': 1
        }
    });
};

export const postRequest = (url, params) => {
    let Authorization = getStore("Authorization");
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        // transformRequest: [function(data) {
        //     let ret = '';
        //     for (let it in data) {
        //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        //     }
        //     ret = ret.substring(0, ret.length - 1);
        //     return ret;
        // }],
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': Authorization,
            'pageNum': 1
        }
    });
};

export const putRequest = (url, params) => {
    let Authorization = getStore("Authorization");
    return axios({
        method: 'put',
        url: `${url}`,
        data: params,
        // transformRequest: [function(data) {
        //     let ret = '';
        //     for (let it in data) {
        //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        //     }
        //     ret = ret.substring(0, ret.length - 1);
        //     return ret;
        // }],
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': Authorization,
            'pageNum': 1
        }
    });
};

export const deleteRequest = (url, params) => {
    let Authorization = getStore("Authorization");
    return axios({
        method: 'delete',
        url: `${url}`,
        params: params,
        headers: {
            'Authorization': Authorization,
            'pageNum': 1
        }
    });
};